import type { Contribution, Setup } from '@/api/giving';
/** Labels use explicit donor IDs only; never infer identity from names or emails. */
export function attributionLabel(row: Contribution, donor?: Setup['donors'][number]) {
  if (donor?.id === row.donor_id) {
    if (donor.kind === 'ANONYMOUS') return {label:'Anonymous',detail:'Explicitly anonymous'};
    if (donor.kind === 'UNRESOLVED') return {label:'Unresolved attribution',detail:'Awaiting explicit attribution'};
    if (donor.kind === 'MEMBER' || donor.kind === 'HOUSEHOLD') {
      return {label:donor.display_name,detail:donor.kind==='MEMBER'?'Member attribution':'Household attribution'};
    }
  }
  return {label:'Donor reference',detail:`Record ${row.donor_id.slice(0,8)}`};
}
